var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 75,
    viewBox: "0 0 99 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.1483 26.9809L98.5094 25.3143L86.9526 17.3609L70.2931 22.8369L78.4073 33.6987L52.2372 7.149L0 0L39.0138 28.6989L22.1419 18.3776L10.6945 17.5218L48.2605 36.7038H50.68L38.1001 74.9712L54.0647 53.9038L46.0599 56.3748L82.0622 39.1747L86.2577 20.4239L86.1483 26.9809Z",
    fill: "#33B9EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBird);
export default __webpack_public_path__ + "static/media/icon_bird.bd8a053f2d6b66889dc9c8d61ca5d3b6.svg";
export { ForwardRef as ReactComponent };